import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import ConfirmationModal from './ConfirmationModal';
import $ from 'jquery';
import editImg from "../../src/components/images/icon-edit.svg";
import delImg from "../../src/components/images/delete.svg";
import MultiSelect from "react-multi-select-component";
import { WithContext as ReactTags } from 'react-tag-input';
import '../components/FetchData.css';
import { TimeOutNotification } from './TimeOutNotification';
import Switch from "react-switch";
export class UserManagement extends Component {
    static displayName = UserManagement.name;

    constructor(props) {
        super(props);
        this.state = {
            forecasts: [], selectedOption: [], tagsobject: [], msbirToranaClientIds: [],
            tags: [{}], rownumber: '', loading: true, studydrp: [], siteIdsdrp: [],
            editUser: false, clientId: '', rownmber: '', show: false, userEmail: '', userRole: '', modalName: '',
            marginTop: "-800px", expireMins: 0, sesExpNotMins: 0
        };
        this.onChangeRole = this.onChangeRole.bind(this);
        this.onChangeSiteId = this.onChangeSiteId.bind(this);
        this.GetClientId = this.GetClientId.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.confirmDelete = this.confirmDelete.bind(this);
        this.confirmUpdate = this.confirmUpdate.bind(this);
        this.confirmChangeLockStatus = this.confirmChangeLockStatus.bind(this);
        this.setSelected = this.setSelected.bind(this);
        this.handleClientIdDelete = this.handleClientIdDelete.bind(this);
        this.handleClientIdAddition = this.handleClientIdAddition.bind(this);
        this.handleMsbirToranaClientIdDelete = this.handleMsbirToranaClientIdDelete.bind(this);
        this.handleMsbirToranaClientIdAddition = this.handleMsbirToranaClientIdAddition.bind(this);
        this.startSessionTimeoutCounter = this.startSessionTimeoutCounter.bind(this);
        this.KeyCodes = {
            TAB: 9,
            SPACE: 32,
            COMMA: 188,
            ENTER: 13
        };

        this.delimiters = [this.KeyCodes.COMMA, this.KeyCodes.ENTER];
    }

    componentDidMount() {
        window.addEventListener('mousemove', this.handleActivity);
        window.addEventListener('keydown', this.handleActivity);
        window.addEventListener('scroll', this.handleActivity);
        this.getAllUsers();
        this.getStudyOptions();
        this.getSiteIdsOptions();
    }
    componentWillUnmount() {
        window.removeEventListener('mousemove', this.handleActivity);
        window.removeEventListener('keydown', this.handleActivity);
        window.removeEventListener('scroll', this.handleActivity);
    }
    handleActivity = () => {
        window['resetCountersOnEvent'](this.state.expireMins, this.state.sesExpNotMins);
    };
    startSessionTimeoutCounter() {
        this.setState({
            expireMins: parseInt(window.localStorage.getItem('ExpireMinutes')),
            sesExpNotMins: parseInt(window.localStorage.getItem('SessionExpireNotificationMinutes'))
        });
        window['startNotificationCounter'](this.state.expireMins, this.state.sesExpNotMins);
    }

    handleClientIdDelete(i, idx) {
        var obj = this.state.tagsobject[idx].filter((tag, index) => index !== i);
        let tagsobject = [...this.state.tagsobject];
        tagsobject[idx] = obj;
        this.setState({
            tagsobject: tagsobject
        });
    }

    handleClientIdAddition(tag, idx) {
        let tagsobject = [...this.state.tagsobject];
        if (tagsobject[idx] === "undefined" || tagsobject[idx] == null) {
            tagsobject[idx] = []
        }

        tagsobject[idx].push(tag);
        this.setState({ tagsobject });
    }

    handleMsbirToranaClientIdDelete(i, idx) {
        var obj = this.state.msbirToranaClientIds[idx].filter((tag, index) => index !== i);
        let msbirToranaClientIds = [...this.state.msbirToranaClientIds];
        msbirToranaClientIds[idx] = obj;
        this.setState({
            msbirToranaClientIds: msbirToranaClientIds
        });
    }

    handleMsbirToranaClientIdAddition(tag, idx) {
        let msbirToranaClientIds = [...this.state.msbirToranaClientIds];
        if (msbirToranaClientIds[idx] === "undefined" || msbirToranaClientIds[idx] === null) {
            msbirToranaClientIds[idx] = []
        }

        msbirToranaClientIds[idx].push(tag);
        this.setState({ msbirToranaClientIds });
    }
    updateUser(userEmail, role, idx) {
        this.setState({
            rownmber: idx,
            show: true,
            userEmail: userEmail,
            userRole: role,
            modalName: 'updateConfirmModal',
        }, () =>
            console.log(this.state));
    }
    changeUserLockStatus(userEmail, lockout, idx) {
        if (lockout == false) {
            this.lockUser(userEmail, lockout)
        }
        else {
            this.unlockUser(userEmail, lockout)
        }
    }
    unlockUser(userEmail, lockout) {
        this.setState({
            show: true,
            userEmail: userEmail,
            checked: lockout,
            modalName: 'changeLockStatusModal',
        }, () =>
            console.log(this.state));
    }
    lockUser(userEmail, lockout) {
        this.setState({
            show: true,
            userEmail: userEmail,
            checked: lockout,
            modalName: 'changeLockStatusModal',
        }, () =>
            console.log(this.state));
    }
    handleClose() {
        this.setState({
            show: false
        }, () =>
            console.log(this.state));
    }

    async onChange(name, value) {
        await this.setState({
            [name]: value
        }, () =>
            console.log(this.state.name));
    }
    deleteUser(userEmail) {
        this.setState({
            show: true,
            userEmail: userEmail,
            modalName: 'deletConfirmModal'
        }, () =>
            console.log(this.state));
    }
    confirmUpdate(idx) {
        var role = $("#role" + idx).val();
        var siteId = $("#siteId" + idx).val();
        var studies = this.state.selectedOption[idx];
        var clientIds = this.state.tagsobject[idx];
        var msbirToranaClientIds = this.state.msbirToranaClientIds[idx];
        $.ajax({
            url: '/UserManagement/UpdateUser',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                userRole: role,
                siteId: siteId,
                userEmail: this.state.userEmail,
                clientIds: JSON.stringify(clientIds),
                studies: JSON.stringify(studies),
                msbirToranaClientIds: JSON.stringify(msbirToranaClientIds)
            },
            success: function (data) {
                $("#role" + idx).val(role)
                $("#siteId" + idx).val(siteId)
            }
        });
    }
    confirmChangeLockStatus() {
        $.ajax({
            url: './UserManagement/ChangeUserLockStatus',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                email: this.state.userEmail,
                lockStatus: this.state.checked
            },
            success: function (data) {
                this.setState({
                    forecasts: data.result, loading: false
                });
            }.bind(this)
        });
    }

    confirmDelete() {
        $.ajax({
            url: '/UserManagement/DeleteUser',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            data: {
                email: this.state.userEmail
            },
            success: function (data) {
                this.setState({
                    forecasts: data, loading: false
                });
            }.bind(this)
        });
    }

    onChangeRole(userEmail, userRole) {
        var userList = this.state.forecasts;
        var changedRoleUser = [];
        var i = 0;
        changedRoleUser = this.state.forecasts;

        for (var user in userList) {
            changedRoleUser[i] = userList[i];
            if (userList[i].email === userEmail)
                changedRoleUser[i].role = userRole;

            i++;
        }

        this.setState({
            registeredUserList: changedRoleUser
        }, () =>
            console.log(this.state));
    }
    onChangeSiteId(userEmail, siteId) {
        var userList = this.state.forecasts;
        var changedSiteIdUser = [];
        var i = 0;
        changedSiteIdUser = this.state.forecasts;

        for (var user in userList) {
            changedSiteIdUser[i] = userList[i];
            if (userList[i].email === userEmail)
                changedSiteIdUser[i].siteId = siteId;

            i++;
        }

        this.setState({
            registeredUserList: changedSiteIdUser
        });
    }
    GetClientId(clientid) {
        this.setState({
            clientId: clientid
        });
    }

    setSelected = (e, idx) => {
        let selectedOption = [...this.state.selectedOption];
        selectedOption[idx] = e;
        this.setState({ selectedOption });
    };

    render() {
        const { selectedOption: [] } = this.state;

        return (
            <div>

                <Button variant="primary" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = '/authentication/register';
                }}>Create User</Button>

                <div>

                    <table className='table table-striped' aria-labelledby="tabelLabel" style={{ width:"100%", tableLayout: "fixed" }}>
                        <thead style={{ backgroundColor: "#1861ac" }}>
                            <tr>
                                <th style={{ width: "15%" }}>Email</th>
                                <th style={{ width: "15%" }}>Torana ID</th>
                                <th style={{ width: "15%" }}>MSBIR Torana ID</th>
                                <th style={{ width: "15%" }}>Site ID</th>
                                <th style={{ width: "10%" }}>Role</th>
                                <th style={{ width: "15%" }}>Studies</th>
                                <th style={{ width: "4%" }}>Update</th>
                                <th style={{ width: "4%" }}>Delete</th>
                                <th style={{ width: "7%" }}>Lock Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.forecasts.map((item, idx) =>
                                <tr key={idx}>
                                    <td>{item.email}</td>

                                    <td>
                                        <ReactTags id={"client" + idx}
                                            tags={this.state.tagsobject[idx] || []}
                                            handleDelete={(e) => this.handleClientIdDelete(e, idx)}
                                            handleAddition={(e) => this.handleClientIdAddition(e, idx)}
                                            delimiters={this.delimiters}
                                            className="form-control"
                                            inputFieldPosition="top"
                                            allowUnique={true}
                                            style={{ height: "38px" }}
                                        />
                                    </td>
                                    <td >
                                        <ReactTags id={"client" + idx}
                                            tags={this.state.msbirToranaClientIds[idx] || []}
                                            handleDelete={(e) => this.handleMsbirToranaClientIdDelete(e, idx)}
                                            handleAddition={(e) => this.handleMsbirToranaClientIdAddition(e, idx)}
                                            delimiters={this.delimiters}
                                            className="form-control"
                                            inputFieldPosition="top"
                                            allowUnique={true}
                                            style={{ height: "20px" }}
                                        />

                                    </td>
                                    <td>
                                        <select className="role-dropdown mb-3" id={"siteId" + idx} value={item.siteId} onChange={(e) => this.onChangeSiteId(item.email, e.target.value)} >
                                            <option value="">Select</option>
                                            {this.state.siteIdsdrp.map((item, index) =>
                                                <option value={item.id} key={index}>{item.institutionName}</option>

                                            )};

                                        </select>

                                    </td>
                                    <td>
                                        <select className="role-dropdown mb-3" id={"role" + idx} value={item.role} onChange={(e) => this.onChangeRole(item.email, e.target.value)} >

                                            <option value="User">User</option>
                                            <option value="Admin">Admin</option>
                                            <option value="Manager">Manager</option>

                                        </select>

                                    </td>
                                    <td>

                                        <MultiSelect id={"study" + idx}
                                            options={this.state.studydrp}
                                            value={this.state.selectedOption[idx] || []}
                                            onChange={(e) => this.setSelected(e, idx)}
                                            labelledBy={"Select"}
                                        />
                                    </td>

                                    <td>
                                        <Button variant="primary" value={item.role} onClick={(e) => this.updateUser(item.email, e.target.value, idx)}>
                                            <img src={editImg} alt="" />
                                        </Button>{' '}
                                    </td>
                                    <td>
                                        <Button variant="primary" value={item.id} onClick={(e) => this.deleteUser(item.email)}>
                                            <img src={delImg} alt="" />

                                        </Button>{' '}
                                    </td>
                                    <td>
                                        <Switch
                                            height={32}
                                            width={82}
                                            className="react-switch"
                                            id="material-switch"
                                            handleDiameter={32}
                                            value={item.email}

                                            onChange={(e) => this.
                                                changeUserLockStatus(item.email, item.lockOutStatus, idx)}
                                            checked={!item.lockOutStatus}
                                            onColor='#50b4e2'
                                            offColor='#D3D3D3'
                                           
                                            uncheckedIcon={
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "black",
                                                        paddingRight: 2
                                                    }}
                                                >
                                                    Lock
                                                </div>
                                            }

                                            checkedIcon={
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "white",
                                                        paddingLeft: 5
                                                    }}
                                                >
                                                    Unlock
                                                </div>
                                            }
                                        />

                                    </td>

                                </tr>

                            )}
                        </tbody>
                    </table>
                    <TimeOutNotification
                        sessionState={this.state}

                    />
                </div>
                <ConfirmationModal
                    stateProps={this.state}
                    handleClose={this.handleClose}
                    confirmDelete={this.confirmDelete}
                    confirmUpdate={this.confirmUpdate}
                    confirmChangeLockStatus={this.confirmChangeLockStatus}
                />
            </div>

        );
    }

    async getAllUsers() {
        await this.setState({
            loading: false
        }, () =>
            console.log(this.state));

        $.ajax({
            url: '/UserManagement/GetUser',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    forecasts: data.result, loading: false
                }, () => {
                    this.bindStudyDropdownWithValues();
                    this.bindToranaClientIds();
                    this.bindMsbirToranaClientIds();
                });
            }.bind(this)
        });
    }

    async bindStudyDropdownWithValues() {
        $.ajax({
            url: '/UserManagement/GetStudyDropdownWithValues',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    selectedOption: data, loading: false
                });
            }.bind(this)
        });
    }
    async bindToranaClientIds() {
        $.ajax({
            url: '/UserManagement/BindMultipleToranaClientId',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    tagsobject: data, loading: false
                });
            }.bind(this)
        });
    }
    async bindMsbirToranaClientIds() {
        $.ajax({
            url: '/UserManagement/BindMultipleMsbirToranaClientId',
            type: 'GET',
            dataType: 'JSON',
            async: true,
            success: function (data) {
                this.setState({
                    msbirToranaClientIds: data, loading: false
                });
            }.bind(this)
        });
    }
    async getStudyOptions() {
        this.setState({
            loading: false
        }, () =>
            console.log(this.state));
        $.ajax({
            url: '/UserManagement/GetStudiesDropdown',
            type: 'GET',
            dataType: 'JSON',
            success: function (data) {
                this.setState({
                    studydrp: data
                });
            }.bind(this)
        });
    }
    async getSiteIdsOptions() {
        this.setState({
            loading: false
        }, () =>
            console.log(this.state));
        $.ajax({
            url: '/UserManagement/GetSiteIdsDropdown',
            type: 'GET',
            dataType: 'JSON',
            success: function (data) {
                this.setState({
                    siteIdsdrp: data
                });
                this.startSessionTimeoutCounter();

            }.bind(this)
        });
    }
}